import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MachineCard, MachineCardImg } from "../Investment/Investment.styled";
import {
  ActivateButton,
  ActivateCard,
  ActivateMinerContainer,
  MachineActivateValueText,
} from "./ActivateMiner.styled";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { activateMiner } from "../../feature/minersOwned/MinersOwnedActions";
import { FormError } from "../Auth.styled";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import { getUserBalance } from "../../feature/wallet/WalletActions";
import ReactLoading from "react-loading";
import SuccessPage from "../SuccessPage/SuccessPage";

const ActivateMiner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [bought, setBought] = useState(false);
  const { balance } = useSelector((state) => state.wallet);
  const { user } = useSelector((state) => state.user);
  const { inputError } = useSelector((state) => state.inputError);
  const { loading } = useSelector((state) => state.minersOwned);
  const selectedMachine =
    location.state !== null && location.state.selectedMachine;
  const data = location.state !== null && location.state.data;
  console.log(data);

  const onSubmit = () => {
    dispatch(activateMiner({ user: user.id, data }))
      .unwrap()
      .then((res) => setBought(true));
  };

  const initialValues = {};

  const validationSchema = Yup.object({});

  const formik = useFormik({
    onSubmit,
    initialValues,
    validationSchema,
  });

  useEffect(() => {
    location.state === null && navigate("/investment");
  }, [location.state, navigate]);

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserBalance({ user: user }));
    dispatch(clearInputError());
  }, [dispatch, user]);

  return (
    <>
      {bought ? (
        <SuccessPage
          message="Miner Re-activated"
          links={[{ link: "/miners-owned", name: "Miners" }]}
        />
      ) : (
        <ActivateMinerContainer>
          <form onSubmit={formik.handleSubmit}>
            <MachineCard style={{ flexDirection: "column" }}>
              <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <div>
                  <MachineCardImg alt="machine1" src={selectedMachine.image} />
                  <MachineActivateValueText>
                    Revenue:{" "}
                    <span style={{ marginBottom: "5px" }}>
                      {selectedMachine.daily_profit} TRX
                    </span>
                  </MachineActivateValueText>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <div>{selectedMachine.name}</div>
                    <MachineActivateValueText style={{ marginBottom: "5px" }}>
                      {selectedMachine.price} TRX
                    </MachineActivateValueText>
                  </div>
                  <div>
                    <div>1 year profit</div>
                    <MachineActivateValueText style={{ marginBottom: "5px" }}>
                      {(selectedMachine.daily_profit * 365).toFixed(2)} TRX
                    </MachineActivateValueText>
                  </div>
                  <div>
                    <div>30 days profit</div>
                    <MachineActivateValueText style={{ marginBottom: "5px" }}>
                      {(selectedMachine.daily_profit * 30).toFixed(2)} TRX
                    </MachineActivateValueText>
                  </div>
                  <div>
                    <div>Earning cycle</div>
                    <MachineActivateValueText style={{ marginBottom: "5px" }}>
                      {selectedMachine.earning_sequence} hour
                    </MachineActivateValueText>
                  </div>
                </div>
              </div>
            </MachineCard>
            <ActivateCard>
              Deposit 50% of the Miner price to re-activate miner
            </ActivateCard>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #7B36EE",
                padding: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  Balance: {balance} TRX
                </div>
              </div>
              <ActivateButton type="submit" disabled={loading}>
                {loading ? (
                  <ReactLoading
                    type={"spinningBubbles"}
                    height={"20px"}
                    width={"20px"}
                  />
                ) : (
                  "Re-Activate Miner"
                )}
              </ActivateButton>
            </div>

            <FormError>
              {inputError !== undefined
                ? inputError[0]
                  ? inputError[0]
                  : null
                : null}
            </FormError>
          </form>
        </ActivateMinerContainer>
      )}
    </>
  );
};

export default ActivateMiner;
